import { c as _c } from "react/compiler-runtime";
import { Field } from 'formik';
import FormikTextInput from '@/components/core/formik/FormikTextInput';
import styled from 'styled-components';
import Typography from '@/components/core/Typography/Typography';
import { FlexCol3XS } from '@/components/Flex';
const LabelWithButtonRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;
export function TextInputWithButton(t0) {
  const $ = _c(15);
  let button;
  let name;
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      name,
      label: t1,
      button,
      withIncreasedHorizontalPadding: t2,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = button;
    $[2] = name;
    $[3] = props;
    $[4] = t1;
    $[5] = t2;
  } else {
    button = $[1];
    name = $[2];
    props = $[3];
    t1 = $[4];
    t2 = $[5];
  }
  const label = t1 === undefined ? "" : t1;
  const withIncreasedHorizontalPadding = t2 === undefined ? false : t2;
  let t3;
  if ($[6] !== button || $[7] !== label || $[8] !== name || $[9] !== props || $[10] !== withIncreasedHorizontalPadding) {
    t3 = t4 => {
      const {
        field,
        form
      } = t4;
      return <FlexCol3XS><LabelWithButtonRow>{label && <label htmlFor={name}><Typography variant="uiType" size="xs" modifier="R">{label}</Typography></label>}{button}</LabelWithButtonRow><FormikTextInput field={field} form={form} {...props} withIncreasedHorizontalPadding={withIncreasedHorizontalPadding} /></FlexCol3XS>;
    };
    $[6] = button;
    $[7] = label;
    $[8] = name;
    $[9] = props;
    $[10] = withIncreasedHorizontalPadding;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== name || $[13] !== t3) {
    t4 = <Field name={name}>{t3}</Field>;
    $[12] = name;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
}